import { render, staticRenderFns } from "./ProviderStatementAuthenticate.vue?vue&type=template&id=b98c8f5c&scoped=true&"
import script from "./ProviderStatementAuthenticate.vue?vue&type=script&lang=js&"
export * from "./ProviderStatementAuthenticate.vue?vue&type=script&lang=js&"
import style0 from "./ProviderStatementAuthenticate.vue?vue&type=style&index=0&id=b98c8f5c&prod&lang=scss&"
import style1 from "./ProviderStatementAuthenticate.vue?vue&type=style&index=1&id=b98c8f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98c8f5c",
  null
  
)

export default component.exports